import { ImageNumber } from './image_number';
import { Sprite } from './sprite';

export class Panel {
  private readonly sprite: Sprite;
  public readonly width: number;
  public readonly height: number;

  public constructor(private readonly number: ImageNumber) {
    this.width = number.width;
    this.height = number.height * 2;
    this.sprite = new Sprite(this.width, this.height);
  }

  public get canvas() {
    return this.sprite.canvas;
  }

  public set(number: number) {
    this.sprite.context.clearRect(0, 0, this.width, this.height);

    const currentNumber = this.number.get(number);
    this.sprite.context.drawImage(
      currentNumber.canvas,
      0,
      currentNumber.height,
      currentNumber.width,
      currentNumber.height,
    );

    const nextNumber = this.number.get(number + 1);
    this.sprite.context.drawImage(nextNumber.canvas, 0, 0, currentNumber.width, currentNumber.height);
  }
}
